module.exports = __webpack_public_path__ + "MI6dgjSRC-R9mVouC/rdc_pro_logo.svg";